module.exports = __webpack_public_path__ + "../resources/images/attachment_sprite-d0734404685d68855c26e515a5998811.png";